import React, { useState, useEffect } from 'react';

import Sidebar from './components/Sidebar/Sidebar';
import Navbar from './components/Navbar/Navbar';
import './App.css';
import OurPlans from './pages/Plans/OurPlans/OurPlans';
import OurPlansAdd from './pages/Plans/OurPlans/OurPlansAdd';
import Features from './pages/Plans/Features/Features';
import Countries from './pages/Localizations/Countries';
import States from './pages/Localizations/States';
import Currencies from './pages/Localizations/Currencies';
import Taxes from './pages/Localizations/Taxes';
import Faqs from './pages/Faq/Faqs';
import FaqCategories from './pages/Faq/FaqCategories';
import Languages from './pages/Languages/Languages';
import Translations from './pages/Translations/Translations';
import Subscriptions from './pages/SubscriptionsMain/Subscriptions';
import Payments from './pages/SubscriptionsMain/Payments';
import UserAccounts from './pages/SubscriptionsMain/UserAccounts';
import UserRoles from './pages/SubscriptionsMain/UserRoles';
import Customers from './pages/SubscriptionsMain/Customers';
import CustomerDetail from './pages/SubscriptionsMain/CustomerDetail';
import UserDetail from './pages/SubscriptionsMain/UserDetailPage';
import NotificationList from './pages/Notifications/NotificationList';
import RecipientGroups from './pages/Notifications/GroupRecipient';
import AddRecipient from './pages/Notifications/AddRecipient';
import EditRecipient from './pages/Notifications/RecipientEdit';
import DetailRecipient from './pages/Notifications/RecipientDetail';
import NotificationCategory from './pages/Notifications/NotificationCategory';
import InternalUsers from './pages/Settings/InternalUsers';
import InternalUserroles from './pages/Settings/InternalUserroles';
import EmailConfiguration from './pages/Settings/EmailConfiguration';
import UserEdit from './pages/SubscriptionsMain/UserEdit';
import BasicExchangeHistory from './pages/Localizations/BasicExchangeHistory';
import PageHeader from './components/common/PageHeader/PageHeader';
import Login from './pages/Login/Login';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate, Outlet } from 'react-router-dom';
import PersonalProfile from './pages/SubscriptionsMain/PersonalProfileDetail';
import { AddPopupProvider } from './context/AddPopupContext';
import GlobalAddPopup from './components/GlobalAddPopup';
import { AddPopupContext } from './context/AddPopupContext';
import UserPermissions from './pages/Settings/UserPermissions';
import NoPermission from './components/common/ExportLabel/NoPermission';
import AccessLogs from './pages/SubscriptionsMain/AccessLogs';
import { ToastContainer } from 'react-toastify';
import ReleaseNotes from './pages/Engagement/ReleaseNotes/ReleaseNotes';
import AddReleaseNotes from './pages/Engagement/ReleaseNotes/AddReleaseNotes';
import EditReleaseNotes from './pages/Engagement/ReleaseNotes/EditReleaseNotes';
import ReleaseNotesDetail from './pages/Engagement/ReleaseNotes/ReleaseNotesDetail';
import UserFeedbacks from './pages/Engagement/UserFeedbacks/UserFeedbacks';
import OurPlansEdit from './pages/Plans/OurPlans/OurPlanEdit';
import OurPlansDetail from './pages/Plans/OurPlans/OurPlansDetail';
import FreeTrialUsers from './pages/FreeTrial/FreeTrialUsers';
import PlanApprovals from './pages/FreeTrial/PlanApprovals';
import Usersrequests from './pages/FreeTrial/Usersrequests';
import FeaturesAdd from './pages/Plans/Features/Addfeatures';
import FeaturesDetail from './pages/Plans/Features/Featuresdetail ';
import FeaturesEdit from './pages/Plans/Features/Featuresedit';

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeOption, setActiveOption] = useState(localStorage.getItem('activeOption') || 'Dashboard');
  const [activeSubOption, setActiveSubOption] = useState(localStorage.getItem('activeSubOption') || null);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [addPopupFields, setAddPopupFields] = useState([]);
  const [popupTitle, setPopupTitle] = useState('');
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  

  const subOptionsMap = {
    Subscription: ['Subscriptions', 'Customers', 'User Accounts', 'User Roles', 'Payments'],
    Plans: ['Our Plans', 'Features'],
    localization: ['Country', 'States', 'Currencies', 'Taxes'],
    FAQ: ['FAQs', 'Faq Categories'],
    Notifications: ['Notification List', 'Recipient Groups'],
  };


  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('authToken');
  
      if (token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
  
      setIsAuthChecked(true);
    };
  
    checkAuth();
  }, []);
  

  const handleLogin = (token) => {
    localStorage.setItem('authToken', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('lastVisitedRoute');
    setIsAuthenticated(false);
  };
  

  const handleMainOptionClick = (optionName) => {
    setActiveOption(optionName);
    if (subOptionsMap[optionName]) {
      setActiveSubOption(subOptionsMap[optionName][0]);
    } else {
      setActiveSubOption(null);
    }
    localStorage.setItem('activeOption', optionName);
    localStorage.setItem('activeSubOption', subOptionsMap[optionName] ? subOptionsMap[optionName][0] : '');
  };

  const handleSubOptionClick = (subOption) => {
    setActiveSubOption(subOption);
    localStorage.setItem('activeSubOption', subOption);
  };

  const handleShowPopup = (title, fields) => {
    setPopupTitle(title);
    setAddPopupFields(fields);
    setIsNewPopupOpen(true);
  };

  if (!isAuthChecked) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      
      <AddPopupContext.Provider
        value={{
          isNewPopupOpen,
          setIsNewPopupOpen,
          addPopupFields,
          setAddPopupFields,
          popupTitle,
          setPopupTitle,
        }}
      >
        <ToastContainer position="top-center" autoClose={3000} />
        <Routes>
          <Route 
            path="/login" 
            element={<Login setIsAuthenticated={handleLogin} />} 
          />
          
          <Route 
              path="/*" 
              element={
                isAuthenticated ? (
          <AuthenticatedLayout
            isAuthenticated={isAuthenticated}
            activeOption={activeOption}
            activeSubOption={activeSubOption}
            handleMainOptionClick={handleMainOptionClick}
            handleSubOptionClick={handleSubOptionClick}
            handleShowPopup={handleShowPopup}
            handleLogout={handleLogout}
          />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            >
            <Route 
              index 
              element={<Navigate to="login" replace />} 
            />

            {/* All your existing routes */}
            <Route path="dashboard" element={<PageHeader pageName="Dashboard" />} />
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="customers" element={<Customers />} />
            <Route path="personal-profile" element={<PersonalProfile />} />
                <Route path="customer-detail/:id" element={<CustomerDetail />} />
                {/* <Route path="customer-edit" element={<CustomerEdit />} /> */}
                <Route path="user-detail/:type/:id" element={<UserDetail />} />
                <Route path="user-edit" element={<UserEdit />} />
                <Route path="payment-detail/:id" element={<Payments />} />
                <Route path='recipient-groups/create' element={<AddRecipient />} />
                <Route path='recipient-groups/edit' element={<EditRecipient />} />
                <Route path='recipient-groups/detail' element={<DetailRecipient />} />
                <Route path="user-accounts" element={<UserAccounts />} />
                <Route path="user-roles" element={<UserRoles />} />
                <Route path="internal-users" element={<InternalUsers />} />
                <Route path="internal-user-roles" element={<InternalUserroles />} />
                <Route path="payments" element={<Payments />} />
                <Route path="our-plans" element={<OurPlans />} />
                <Route path="features" element={<Features />} />
                <Route path="countries" element={<Countries />} />
                <Route path="states" element={<States />} />
                <Route path="currencies" element={<Currencies />} />
                <Route path="basic-exchange-history" element={<BasicExchangeHistory />} />
                <Route path="taxes" element={<Taxes />} />
                <Route path="faqs" element={<Faqs />} />
                <Route path="faq-categories" element={<FaqCategories />} />
                <Route path="languages" element={<Languages />} />
                <Route path="translations" element={<Translations />} />
                <Route path="notification-list" element={<NotificationList />} />
                <Route path="notification-category" element={<NotificationCategory />} />
                <Route path="recipient-groups" element={<RecipientGroups />} />
                <Route path="email-configuration" element={<EmailConfiguration />} />  
                <Route path="user-permissions" element={<UserPermissions />} />  
                <Route path="permission-denied" element={<NoPermission />} />   
                <Route path="access-logs" element={<AccessLogs/>} />     
                <Route path="release-notes" element={<ReleaseNotes/>} />     
                <Route path="release-notes/create" element={<AddReleaseNotes/>} />     
                <Route path="release-notes/edit/:id" element={<EditReleaseNotes/>} />     
                <Route path="release-notes/detail/:id" element={<ReleaseNotesDetail/>} />     
                <Route path="user-feedbacks" element={<UserFeedbacks/>} />     
                <Route path="our-plans/create" element={<OurPlansAdd/>} /> 
                <Route path="our-plans/edit/:id" element={<OurPlansEdit/>} />   
                <Route path="our-plans/detail/:id" element={<OurPlansDetail/>} />  
                <Route path="free-trial-users" element={<FreeTrialUsers/>} />  
                <Route path="plan-approvals" element={<PlanApprovals/>} />   
                <Route path="users-requests" element={<Usersrequests/>} />   
                <Route path="features/add" element={<FeaturesAdd />} />
                <Route path="features/detail/:id" element={<FeaturesDetail />} />
                <Route path="features/edit/:id" element={<FeaturesEdit />} />
          </Route>
        </Routes>
        <GlobalAddPopup />
      </AddPopupContext.Provider>
    
    </Router>
  );
}

function AuthenticatedLayout({
  isAuthenticated, 
  activeOption,
  activeSubOption,
  handleMainOptionClick,
  handleSubOptionClick,
  handleShowPopup,
  handleLogout,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !location.pathname.includes('/login')) {
      localStorage.setItem('lastVisitedRoute', location.pathname);
    }
  }, [isAuthenticated, location]);

  return (
    <AddPopupProvider>
    <div className="app">

      <Navbar onLogout={handleLogout} />
      <div className="side-bar-container">

        <Sidebar
          activeOption={activeOption}
          activeSubOption={activeSubOption}
          onMainOptionClick={handleMainOptionClick}
          onSubOptionClick={handleSubOptionClick}
          showPopup={handleShowPopup}
        />

        <div className="main-content">
          <Outlet />
        </div>
      </div>
      <GlobalAddPopup /> 
    </div>
    </AddPopupProvider>
  );
}


export default App;
